export const MoneyTimeIcon = ({
  strokeColor = "var(--color-txt-secondary)",
  ...props
}: any) => (
  <svg {...props} width="26" height="26" viewBox="0 0 26 26" fill="none">
    <g id="vuesax/outline/money-time">
      <g id="money-time">
        <path
          id="Vector"
          d="M13.0001 16.5208C11.0609 16.5208 9.47925 14.9392 9.47925 13C9.47925 11.0608 11.0609 9.47916 13.0001 9.47916C14.9392 9.47916 16.5209 11.0608 16.5209 13C16.5209 14.9392 14.9392 16.5208 13.0001 16.5208ZM13.0001 11.1042C11.9601 11.1042 11.1042 11.96 11.1042 13C11.1042 14.04 11.9601 14.8958 13.0001 14.8958C14.0401 14.8958 14.8959 14.04 14.8959 13C14.8959 11.96 14.0401 11.1042 13.0001 11.1042Z"
          fill={strokeColor}
        />
        <path
          id="Vector_2"
          d="M20.0417 16.5208C19.5976 16.5208 19.2292 16.1525 19.2292 15.7083V10.2917C19.2292 9.8475 19.5976 9.47916 20.0417 9.47916C20.4859 9.47916 20.8542 9.8475 20.8542 10.2917V15.7083C20.8542 16.1525 20.4859 16.5208 20.0417 16.5208Z"
          fill={strokeColor}
        />
        <path
          id="Vector_3"
          d="M5.41659 24.6458C2.57825 24.6458 0.270752 22.3383 0.270752 19.5C0.270752 16.6617 2.57825 14.3542 5.41659 14.3542C8.25492 14.3542 10.5624 16.6617 10.5624 19.5C10.5624 22.3383 8.25492 24.6458 5.41659 24.6458ZM5.41659 15.9792C3.47742 15.9792 1.89575 17.5608 1.89575 19.5C1.89575 21.4392 3.47742 23.0208 5.41659 23.0208C7.35575 23.0208 8.93742 21.4392 8.93742 19.5C8.93742 17.5608 7.35575 15.9792 5.41659 15.9792Z"
          fill={strokeColor}
        />
        <path
          id="Vector_4"
          d="M4.3333 21.3958C4.06247 21.3958 3.79162 21.255 3.63995 21.0058C3.41245 20.6267 3.53163 20.1175 3.92163 19.89L4.74497 19.3917C4.82081 19.3484 4.87497 19.2508 4.87497 19.1642V18.1567C4.87497 17.7125 5.2433 17.3442 5.68747 17.3442C6.13163 17.3442 6.49997 17.7125 6.49997 18.1567V19.1642C6.49997 19.825 6.14249 20.4533 5.57916 20.7892L4.75582 21.2875C4.62582 21.3634 4.47413 21.3958 4.3333 21.3958Z"
          fill={strokeColor}
        />
        <path
          id="Vector_5"
          d="M18.4167 22.4792H9.20842C8.76425 22.4792 8.39592 22.1108 8.39592 21.6667C8.39592 21.2225 8.76425 20.8542 9.20842 20.8542H18.4167C21.5151 20.8542 23.0209 19.3483 23.0209 16.25V9.75C23.0209 6.65167 21.5151 5.14584 18.4167 5.14584H7.58342C4.48508 5.14584 2.97925 6.65167 2.97925 9.75V16.4667C2.97925 16.9108 2.61091 17.2792 2.16675 17.2792C1.72258 17.2792 1.35425 16.9108 1.35425 16.4667V9.75C1.35425 5.79584 3.62925 3.52084 7.58342 3.52084H18.4167C22.3709 3.52084 24.6459 5.79584 24.6459 9.75V16.25C24.6459 20.2042 22.3709 22.4792 18.4167 22.4792Z"
          fill={strokeColor}
        />
      </g>
    </g>
  </svg>
);
